module.exports = __webpack_public_path__ + "img/test.3165181e.jpg";